import React, { useCallback } from 'react';
import PropTypes from 'prop-types';
import PAGE_TYPES from 'tradera-constants/page-types';
import {
    stripPaginationFromQueryParameters,
    toSearchString
} from 'tradera-utils/url';
import * as gtm from 'tradera-apps/tradera/components/discover/helpers/search-gtm';
import { useTranslator } from 'tradera-lang/translate';
import { TreeNavigation } from 'tradera-components/tree-navigation/tree-navigation';

const mapTree = (tree, searchString) =>
    tree.map(category => ({
        ...category,
        isActive: category.status === 'active',
        url: searchString ? `${category.url}?${searchString}` : category.url,
        children:
            category.children?.length > 0
                ? mapTree(category.children)
                : category.children
    }));

export const FilterCategories = ({
    filterCategories,
    handleCategoryChange,
    handleSearchCategoryChange,
    pageType,
    queryParams
}) => {
    const { t } = useTranslator();
    const categoryResultPage = pageType === PAGE_TYPES.CATEGORY_RESULT_PAGE;
    const onCategoryClick = useCallback(
        (category, event) => {
            let strPath = [...category.path, category.name].join(' > ');
            gtm.trackFilter('categorySelected', strPath);

            if (categoryResultPage) {
                handleCategoryChange(category, event);
            } else {
                event.preventDefault();
                handleSearchCategoryChange(category);
            }
        },
        [categoryResultPage, handleCategoryChange, handleSearchCategoryChange]
    );
    const onShowMoreClick = () =>
        gtm.trackFilter('categorySelected', 'Button - View all');

    const categories = [filterCategories?.categoryTree];

    if (!categories) {
        return null;
    }

    const searchString = categoryResultPage
        ? toSearchString(stripPaginationFromQueryParameters(queryParams))
        : null;
    const tree = mapTree(categories, searchString);

    return (
        <div data-test-filter-categories>
            <TreeNavigation
                id="filter-categories"
                tree={tree}
                isNarrow={!categoryResultPage}
                onItemClick={onCategoryClick}
                onShowMoreClick={onShowMoreClick}
                showMoreText={t('searchResults_categoriesFilter_showMore')}
            />
        </div>
    );
};

FilterCategories.propTypes = {
    filterCategories: PropTypes.shape({
        categoryTree: PropTypes.object,
        parameter: PropTypes.string,
        type: PropTypes.string
    }).isRequired,
    handleCategoryChange: PropTypes.func,
    handleSearchCategoryChange: PropTypes.func,
    pageType: PropTypes.string.isRequired,
    queryParams: PropTypes.object.isRequired
};
